var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 18.3327C14.6017 18.3327 18.3327 14.6017 18.3327 9.99935C18.3327 5.39698 14.6017 1.66602 9.99935 1.66602C5.39698 1.66602 1.66602 5.39698 1.66602 9.99935C1.66602 14.6017 5.39698 18.3327 9.99935 18.3327ZM10.8544 7.72849C10.6567 7.58964 10.4328 7.44603 10.201 7.30505C9.30729 6.7616 8.86046 6.48988 8.4597 6.79072C8.05893 7.09156 8.02251 7.72135 7.94967 8.98093C7.92907 9.33714 7.91602 9.68634 7.91602 9.99939C7.91602 10.3124 7.92907 10.6616 7.94967 11.0178C8.02251 12.2774 8.05893 12.9072 8.45969 13.2081C8.86046 13.5089 9.30729 13.2372 10.201 12.6937C10.4328 12.5527 10.6567 12.4091 10.8544 12.2703C11.0798 12.112 11.3251 11.9221 11.5724 11.7204C12.4681 10.9897 12.916 10.6243 12.916 9.99939C12.916 9.37449 12.4681 9.00912 11.5724 8.27839C11.3251 8.07667 11.0798 7.88675 10.8544 7.72849Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/playCircle.662301d2b8a94ba1f9d8110449161cbb.svg";
export { ForwardRef as ReactComponent };